import { BadgeCheck, Truck, Headset, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

// The reassurance row every storefront carries above the fold of the listings —
// each point links to the page that actually substantiates it, rather than
// being a decorative badge.
const POINTS = [
  {
    icon: BadgeCheck,
    title: "ISO 27001 & 9001 certified",
    body: "Audited quality and information-security management",
    to: "/certifications",
  },
  {
    icon: ShieldCheck,
    title: "Warranty on every order",
    body: "Up to 12 months on refurbished, manufacturer terms on new",
    to: "/policies/warranty",
  },
  {
    icon: Truck,
    title: "Nationwide delivery",
    body: "Dispatched from Indore, shipped across India",
    to: "/policies/delivery",
  },
  {
    icon: Headset,
    title: "Quotes in one working day",
    body: "Talk to an engineer, not a call centre",
    to: "/policies/returns",
  },
];

const ValueStrip = () => (
  <section className="border-y border-gray-200 bg-white">
    <div className="mx-auto grid max-w-[88rem] grid-cols-2 gap-px bg-gray-200 lg:grid-cols-4">
      {POINTS.map(({ icon: Icon, title, body, to }) => (
        <Link
          key={title}
          to={to}
          className="group flex items-start gap-3 bg-white px-4 py-4 transition-colors hover:bg-gray-50"
        >
          <Icon
            size={20}
            className="mt-0.5 shrink-0 text-[var(--website-primary-color)]"
          />
          <span>
            <span className="block text-[0.82rem] font-bold text-gray-900 group-hover:underline">
              {title}
            </span>
            <span className="mt-0.5 block text-[0.72rem] leading-snug text-gray-500">
              {body}
            </span>
          </span>
        </Link>
      ))}
    </div>
  </section>
);

export default ValueStrip;
